import { Tag, TagProps } from 'antd';
import classNames from 'classnames';

interface MTagProps extends TagProps {}

const MTag: React.FC<MTagProps> = (props) => {
  const { className, ...restProps } = props;
  return <Tag {...restProps} className={classNames('trojan-tag', className)} />;
};

export default MTag;
